import { render, staticRenderFns } from "./Encabezado.vue?vue&type=template&id=18db5382&scoped=true&"
import script from "./Encabezado.vue?vue&type=script&lang=js&"
export * from "./Encabezado.vue?vue&type=script&lang=js&"
import style0 from "./Encabezado.vue?vue&type=style&index=0&id=18db5382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db5382",
  null
  
)

export default component.exports